export const calculateSubDisciplineTotal = (selected: any[], type: 1 | 2, dep: any) => {
  const selectedCodes = Object.entries(selected)
    .filter(([code, isSelected]) => isSelected)
    .map(([code]) => code);
  if (selectedCodes.length === 0) return 0;
  const targetResourceTypeCodes = dep.resourceType
    .filter((item) => selectedCodes.includes(item.disciplineCode))
    .map((item) => item.resourceTypeCode);
  if (targetResourceTypeCodes.length === 0) return 0;
  const matchedItems = dep.resourceLoadingConstraint.filter((item) => targetResourceTypeCodes.includes(item.resourceTypeCode));
  if (type === 1) {
    return matchedItems.length;
  } else if (type === 2) {
    return matchedItems.map((a: any) => a.roleMpUpper || 0).reduce((a, b) => a + b, 0);
  }
  return 0;
};

export const calculateDisciplineTotal = (selected: any[], type: 1 | 2, dep: any) => {
  const selectedCodes = Object.entries(selected)
    .filter(([code, isSelected]) => isSelected)
    .map(([code]) => code);
  if (selectedCodes.length === 0) return 0;
  const targetResourceTypeCodes = dep.resourceType
    .filter((item) => selectedCodes.includes(item.disciplineCode))
    .map((item) => item.resourceTypeCode);
  if (targetResourceTypeCodes.length === 0) return 0;
  const matchedItems = dep.resourceLoadingConstraint.filter((item) => targetResourceTypeCodes.includes(item.parentResourceTypeCode));
  if (type === 1) {
    return matchedItems.length;
  } else if (type === 2) {
    return matchedItems.filter((a: any) => a.parentResourceTypeCode === a.resourceTypeCode).map((a: any) => a.disciplineMpUpper || 0).reduce((a, b) => a + b, 0);
  }
  return 0;
};

export const calculateAreaTotal = (selected: any[], type: 1 | 2, dep: any) => {
  const selectedAreaNames = Object.entries(selected)
    .filter(([areaName, isSelected]) => isSelected)
    .map(([areaName]) => areaName);

  if (selectedAreaNames.length === 0) return 0;

  const matchedAreas = dep.area.filter((item) => selectedAreaNames.includes(item.area));

  if (type === 1) {
    return matchedAreas.length;
  } else if (type === 2) {
    return matchedAreas.map((a: any) => Number(a.areaMpUpper) || 0).reduce((a, b) => a + b, 0);
  }

  return 0;
};
